import BrandModifier from "../components/BrandModifier";
import useModalForm from "../../../@hooks/useModalForm";
import service from "../../../@services";
export default function useAddBrand() {
  const { open } = useModalForm(BrandModifier);

  const addBrand = (brand={}) => {
    return new Promise((resolve,reject)=>{
      open(
        async (data) => {
          const res = await brand.id
          ? service.brand.updateBrand(data)
          : service.brand.createBrand(data);
          return res.then((brandId)=>{
            resolve(brandId)
          }).catch((e) => {
            reject(e)
            throw e
          })
        },
        brand,
        {
          title: brand.id?"编辑品牌":"新增品牌",
        }
      );
    })
  };
  return {
    addBrand,
  };
}